import { Pipe, PipeTransform } from '@angular/core';
import { FinancialUtilsService } from '../../core/services';


/**
 * Converts a large number to a short version with a suffix provided by the {@Link FinancialUtilsService}
 * The lower unite display is million represented
 * If currency is passed as argument, sets the currency symbol in its wide version
 */
@Pipe({
    name: 'rmsFormatMinMillionMoney',
    standalone: false
})
export class RmsFormatMinMillionMoneyPipe implements PipeTransform {
  transform(value: any, currency?: any, decimal?: number): string {
    if (value === null) {
      return value;
    }
    if (currency) {
      return `${FinancialUtilsService.convertMoneyMinMillionCurrency(value, currency, decimal)}`;
    }
    return FinancialUtilsService.convertMoneyMinMillion(value, decimal);
  }

}
